import { Controller } from "@hotwired/stimulus"

const GISCUS_ORIGIN = "https://giscus.app"

export default class extends Controller {
  static targets = ["menu", "button", "icon"]

  connect() {
    const savedTheme = localStorage.getItem("theme") || "default"
    this.updateIcon(savedTheme)
    this.syncGiscusTheme()
  }

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")

    const isExpanded = !this.menuTarget.classList.contains("hidden")
    this.buttonTarget.setAttribute("aria-expanded", isExpanded)
  }

  select(event) {
    event.stopPropagation()
    const theme = event.currentTarget.dataset.themeName
    this.applyTheme(theme)
    this.updateIcon(theme)
    this.menuTarget.classList.add("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "false")

    localStorage.setItem("theme", theme)
  }

  applyTheme(theme) {
    const html = document.documentElement

    if (theme === "default") {
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches
      html.setAttribute("data-theme", prefersDark ? "dark" : "light")
    } else {
      html.setAttribute("data-theme", theme)
    }

    this.setGiscusTheme(this.currentGiscusTheme())
  }

  setGiscusTheme(theme) {
    const iframe = document.querySelector("iframe.giscus-frame")
    if (!iframe) return

    iframe.contentWindow.postMessage(
      { giscus: { setConfig: { theme } } },
      GISCUS_ORIGIN
    )
  }

  currentGiscusTheme() {
    return document.documentElement.getAttribute("data-theme") === "dark" ? "dark" : "light"
  }

  syncGiscusTheme() {
    const theme = this.currentGiscusTheme()
    const script = document.querySelector("script[src*='giscus.app']")
    if (script) script.setAttribute("data-theme", theme)
    this.setGiscusTheme(theme)
  }

  updateIcon(theme) {
    if (!this.hasIconTarget) return

    let effectiveTheme = theme
    if (theme === "default") {
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches
      effectiveTheme = prefersDark ? "dark" : "light"
    }

    const sunIcon = `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"></path>`
    const moonIcon = `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"></path>`

    this.iconTarget.innerHTML = effectiveTheme === "light" ? sunIcon : moonIcon
  }

  clickOutside(event) {
    if (!this.element.contains(event.target) && !this.menuTarget.classList.contains("hidden")) {
      this.menuTarget.classList.add("hidden")
      this.buttonTarget.setAttribute("aria-expanded", "false")
    }
  }
}
